import { connect } from 'react-redux'
import { selectors } from '../../features/Settings'
import TitleBar from '../../components/TitleBar'
import localize from '../../store/localize'
import strings from '../../components/TitleBar/title-bar.json'

// todo: settings Fix language
function mapStateToProps(state) {
    return {
        localize: value => localize(strings, selectors.getLanguage(state), value),
    }
}

export default connect(mapStateToProps, null)(TitleBar)



// WEBPACK FOOTER //
// ./src/containers/TitleBar/title-bar.js